import { CONTACT_PREFERENCE_INTERNAL_VIEW } from "../../actions/policy/policyActions";
import { getLayout } from "../../layout/Layout";

const initialState = {
  layout: getLayout(),
  contactPreferencenceInternalView: false
};

export default function layoutReducer(state = initialState, action = {}) {
  if (action.type === CONTACT_PREFERENCE_INTERNAL_VIEW) {
    return {
      ...state,
      contactPreferencenceInternalView: true
    };
  } else {
    return state;
  }
}
